import { ILaya } from "../../../ILaya";
import { Event } from "../../events/Event";
import { Matrix3x3 } from "../../maths/Matrix3x3";
import { Point } from "../../maths/Point";
import { Vector2 } from "../../maths/Vector2";
import { Vector4 } from "../../maths/Vector4";
import { Shader3D } from "../../RenderEngine/RenderShader/Shader3D";
import { RenderState2D } from "../../webgl/utils/RenderState2D";
import { Sprite } from "../Sprite";
import { SpriteConst } from "../SpriteConst";
export class Camera2D extends Sprite {
    static shaderValueInit() {
        Camera2D.VIEW2D = Shader3D.propertyNameToID("u_view2D");
        Camera2D.SHADERDEFINE_CAMERA2D = Shader3D.getDefineByName("CAMERA2D");
    }
    get ignoreRotation() {
        return this._ignoreRotation;
    }
    set ignoreRotation(value) {
        this._ignoreRotation = value;
    }
    get isMain() {
        return this._isMain;
    }
    set isMain(value) {
        if (this._ownerArea) {
            if (value) {
                this._ownerArea._setMainCamera(this);
                this._isMain = true;
            }
            else {
                if (this._ownerArea.mainCamera == this) {
                    this._ownerArea._setMainCamera(null);
                    this._isMain = false;
                }
            }
        }
        this._isMain = value;
    }
    _setUnBelongScene() {
        if (this._ownerArea != null) {
            if (this._ownerArea.mainCamera == this)
                this._ownerArea._setMainCamera(null);
            this._ownerArea = null;
        }
        super._setUnBelongScene();
    }
    _findOwnerArea() {
        let ele = this;
        while (ele) {
            if (ele === this._scene || ele === ILaya.stage)
                break;
            if ((ele._renderType & SpriteConst.AREA2D) !== 0) {
                this._ownerArea = ele;
                if (this._isMain && !this._ownerArea.mainCamera)
                    this._ownerArea._setMainCamera(this);
                break;
            }
            ele = ele._parent;
        }
        if (this._ownerArea == null) {
            console.warn("Camera2D must be a descendant of Area2D");
        }
    }
    get zoom() {
        return this._zoom;
    }
    set zoom(value) {
        if (value) {
            value.cloneTo(this._zoom);
            this._struct.setRepaint();
            this.parentRepaint();
        }
    }
    get limit_Left() {
        return this._limit_Left;
    }
    set limit_Left(value) {
        this._limit_Left = value;
    }
    get limit_Right() {
        return this._limit_Right;
    }
    set limit_Right(value) {
        this._limit_Right = value;
    }
    get limit_Bottom() {
        return this._limit_Bottom;
    }
    set limit_Bottom(value) {
        this._limit_Bottom = value;
    }
    get limit_Top() {
        return this._limit_Top;
    }
    set limit_Top(value) {
        this._limit_Top = value;
    }
    get positionSmooth() {
        return this._positionSmooth;
    }
    set positionSmooth(value) {
        this._positionSmooth = value;
    }
    get positionSpeed() {
        return this._positionSpeed;
    }
    set positionSpeed(value) {
        this._positionSpeed = value;
    }
    get dragHorizontalEnable() {
        return this._dragHorizontalEnable;
    }
    set dragHorizontalEnable(value) {
        this._dragHorizontalEnable = value;
    }
    get dragVerticalEnable() {
        return this._dragVerticalEnable;
    }
    set dragVerticalEnable(value) {
        this._dragVerticalEnable = value;
    }
    get drag_Left() {
        return this._drag_Left;
    }
    set drag_Left(value) {
        this._drag_Left = value;
    }
    get drag_Right() {
        return this._drag_Right;
    }
    set drag_Right(value) {
        this._drag_Right = value;
    }
    get drag_Top() {
        return this._drag_Top;
    }
    set drag_Top(value) {
        this._drag_Top = value;
    }
    get drag_Bottom() {
        return this._drag_Bottom;
    }
    set drag_Bottom(value) {
        this._drag_Bottom = value;
    }
    get cameraMatrix() {
        return this._cameraMatrix;
    }
    getCameraPos() {
        return this._cameraPos;
    }
    constructor() {
        super();
        this._cameraPos = new Vector2();
        this._cameraSmoothPos = new Vector2();
        this._firstUpdate = true;
        this._cameraMatrix = new Matrix3x3();
        this._cameraInvertMatrix = new Matrix3x3();
        this._ignoreRotation = true;
        this.visiableLayer = -1;
        this._viewRect = new Vector2();
        this._limit_Left = -10000000;
        this._limit_Right = 10000000;
        this._limit_Top = -10000000;
        this._limit_Bottom = 10000000;
        this._drag_Left = 0.2;
        this._drag_Right = 0.2;
        this._drag_Top = 0.2;
        this._drag_Bottom = 0.2;
        this._positionSmooth = false;
        this._rect = new Vector4();
        this._zoom = new Vector2(1, 1);
    }
    _getScreenSize() {
        this._viewRect.setValue(RenderState2D.width, RenderState2D.height);
        return this._viewRect;
    }
    onEnable() {
        this.on(Event.TRANSFORM_CHANGED, this, this._onTransChanged);
    }
    onDisable() {
        this.off(Event.TRANSFORM_CHANGED, this, this._onTransChanged);
    }
    _onTransChanged(e) {
        this._struct.setRepaint();
        this.parentRepaint();
    }
    _getCameraTransform() {
        let viewport = this._getScreenSize();
        let curPosPoint = Point.TEMP;
        this.globalTrans.getPos(curPosPoint);
        let extendHorizental = viewport.x * 0.5 * this._zoom.x;
        let extendVertical = viewport.y * 0.5 * this._zoom.y;
        if (!this._firstUpdate) {
            if (this._dragHorizontalEnable) {
                this._cameraPos.x = Math.min(this._cameraPos.x, curPosPoint.x + extendHorizental * this._drag_Left);
                this._cameraPos.x = Math.max(this._cameraPos.x, curPosPoint.x - extendHorizental * this._drag_Right);
            }
            else {
                this._cameraPos.x = curPosPoint.x;
            }
            if (this._dragVerticalEnable) {
                this._cameraPos.y = Math.min(this._cameraPos.y, curPosPoint.y + extendVertical * this._drag_Top);
                this._cameraPos.y = Math.max(this._cameraPos.y, curPosPoint.y - extendVertical * this._drag_Bottom);
            }
            else {
                this._cameraPos.y = curPosPoint.y;
            }
            let sceneRect_left = this._cameraPos.x - extendHorizental;
            let sceneRect_right = sceneRect_left + viewport.x;
            let sceneRect_top = this._cameraPos.y - extendVertical;
            let sceneRect_bottom = sceneRect_top + viewport.y;
            if (sceneRect_left < this._limit_Left) {
                this._cameraPos.x -= sceneRect_left - this._limit_Left;
            }
            if (sceneRect_right > this._limit_Right) {
                this._cameraPos.x -= sceneRect_right - this._limit_Right;
            }
            if (sceneRect_bottom > this._limit_Bottom) {
                this._cameraPos.y -= sceneRect_bottom - this._limit_Bottom;
            }
            if (sceneRect_top < this._limit_Top) {
                this._cameraPos.y -= sceneRect_top - this._limit_Top;
            }
            if (this._positionSmooth) {
                let epsilon = 0.01;
                let speed = Math.max(epsilon, Math.min(1.0, this._positionSpeed * 0.16));
                let deltaX = this._cameraPos.x - this._cameraSmoothPos.x;
                let deltaY = this._cameraPos.y - this._cameraSmoothPos.y;
                let transX = deltaX * speed;
                let transY = deltaY * speed;
                if (Math.abs(transX) < epsilon && Math.abs(transY) < epsilon) {
                    this._cameraSmoothPos.x = this._cameraPos.x;
                    this._cameraSmoothPos.y = this._cameraPos.y;
                }
                else {
                    this._cameraSmoothPos.x += transX;
                    this._cameraSmoothPos.y += transY;
                }
            }
            else {
                this._cameraSmoothPos.x = this._cameraPos.x;
                this._cameraSmoothPos.y = this._cameraPos.y;
            }
        }
        else {
            this._cameraSmoothPos.x = this._cameraPos.x = curPosPoint.x;
            this._cameraSmoothPos.y = this._cameraPos.y = curPosPoint.y;
            this._firstUpdate = false;
        }
        if (!this.ignoreRotation) {
            if (this.rotationSmooth) {
            }
            else {
                this._cameraRotation = this.globalTrans.rotation;
            }
        }
        else {
            this._cameraRotation = 0;
        }
        this._rect.setValue(this._cameraSmoothPos.x - extendHorizental, this._cameraSmoothPos.x + extendHorizental, this._cameraSmoothPos.y - extendVertical, this._cameraSmoothPos.y + extendVertical);
        Matrix3x3.createMatrixFromValue(this._cameraSmoothPos, this._cameraRotation * Math.PI / 180, this._zoom, this._cameraMatrix);
        this._cameraMatrix.invert(this._cameraInvertMatrix);
        return this._cameraInvertMatrix;
    }
}
